module.exports = __webpack_public_path__ + "img/search-plus.232b749c.svg";